import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IContactMethod } from '../interfaces/contact-method';
import { IContactOutcome } from '../interfaces/contact-outcome';
import { IJobContact } from '../interfaces/job-contact';
import { IJobFilter } from '../interfaces/job/job-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class JobsContactService extends EditService<IJobContact, IJobFilter> {
  url = '/api/job-contact';
  entityTitle = 'Job Contact';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getAllMethods(): Promise<IContactMethod[]> {
    return this.handleRequest(
      this.http.get(`${this.url}/getmethods`),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
  }

  public getAllOutcomes(): Promise<IContactOutcome[]> {
    return this.handleRequest(
      this.http.get(`${this.url}/getoutcomes`),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
  }
}
